/**
 * RISKS-HOME.ROUTE
 * Entry point for the DUERP module via /duerp
 * Renders RisksHub within NavApp without switching featureConnected
 */
import NavApp from "@/nav/nav.app"
import { RisksHub } from "@/features/risks/entities/risk/ui/RisksHub"
import { useAppSelector } from "@/core/root-reducer"
import organizationStore from "@/features/adm/entities/organization/model/organization.store"
import PagePlaceholder from "@/components/page-placeholder"
import { useNavigate } from "react-router-dom"

export default function RisksHomeRoute() {
  const navigate = useNavigate()
  const organizationExists = useAppSelector(organizationStore.selectors.exists)
  const _session = useAppSelector((state) => state._session)

  let content: React.ReactNode

  if (_session.risksRole === "USER") {
    content = (
      <PagePlaceholder
        image="assistant"
        title={`Vous n'êtes pas administrateur du compte ${_session.accountName}`}
        help="Veuillez contacter le support technique IDTree à l'adresse support@id-tree.com pour demander un accès."
      />
    )
  } else if (!organizationExists) {
    content = (
      <PagePlaceholder
        image="assistant"
        button="Créer une organisation"
        title="Aucune organisation n'existe pour le compte"
        help={
          _session.connectedAsSupervisor
            ? undefined
            : "Veuillez contacter le support technique IDTree à l'adresse support@id-tree.com pour créer une organisation."
        }
        onClick={_session.connectedAsSupervisor ? () => navigate("/adm/settings?tab=TAB_MODULE_RISKS") : undefined}
      />
    )
  } else {
    content = <RisksHub />
  }

  return <NavApp>{content}</NavApp>
}
